{
  "nav": {
    "section": "Navigation"
  },
  "auth": {
    "agree": "I agree to",
    "createAccount": "Create account",
    "createNewAccount": "Create New Account",
    "email": "Email",
    "login": "Login",
    "password": "Password",
    "recover_password": "Recover password",
    "sign_up": "Sign Up",
    "keep_logged_in": "Keep me logged in",
    "termsOfUse": "Terms of Use.",
    "reset_password": "Reset password"
  },
  "account": {
    "login": "Log in",
    "logout": "Log out",
    "credits": "credits",
    "balance": "Balance",
    "loginTitle": "Log in / Sign up",
    "loginDesc": "Passwordless — we'll email you a one-click login link.",
    "emailLabel": "Email",
    "sendLink": "Send login link",
    "linkSent": "Check your inbox",
    "linkSentDesc": "We emailed a login link to {email}. Click it to finish signing in.",
    "invalidEmail": "Please enter a valid email address.",
    "close": "Close",
    "buyCredits": "Buy credits",
    "buyTitle": "Buy credits",
    "buyDesc": "Top up your wallet. Credits are shared across all tools.",
    "popular": "Popular",
    "bonusSuffix": "+{n} bonus",
    "buyAction": "Buy",
    "buyNote": "Secure payment via Stripe. Credits are added right after payment.",
    "checkoutError": "Could not start checkout. Please try again.",
    "paySuccess": "Payment successful — credits added.",
    "payCancel": "Payment canceled.",
    "loginTitlePw": "Log in",
    "signupTitle": "Create account",
    "forgotTitle": "Reset password",
    "resetTitle": "Set a new password",
    "passwordLabel": "Password",
    "newPassword": "New password",
    "confirmPassword": "Confirm password",
    "signIn": "Log in",
    "signUp": "Sign up",
    "sendReset": "Send reset link",
    "updatePassword": "Update password",
    "forgotLink": "Forgot password?",
    "noAccount": "No account?",
    "haveAccount": "Already have an account?",
    "checkInbox": "Check your inbox",
    "resetSent": "We emailed a password reset link to {email}.",
    "signupConfirm": "We emailed a confirmation link to {email}. Click it to activate your account.",
    "pwTooShort": "Password must be at least 6 characters.",
    "pwMismatch": "Passwords do not match.",
    "loginFailed": "Incorrect email or password."
  },
  "404": {
    "title": "This page’s gone fishing.",
    "text": "If you feel that it’s not right, please send us a message at ",
    "back_button": "Back to dashboard"
  },
  "typography": {
    "primary": "Primary text styles",
    "secondary": "Secondary text styles"
  },
  "dashboard": {
    "versions": "Versions",
    "setupRemoteConnections": "Setup Remote Connections",
    "currentVisitors": "Current Visitors",
    "navigationLayout": "navigation layout",
    "topBarButton": "Top Bar",
    "sideBarButton": "Side Bar"
  },
  "language": {
    "brazilian_portuguese": "Português",
    "english": "English",
    "spanish": "Spanish",
    "simplified_chinese": "Simplified Chinese",
    "persian": "Persian"
  },
  "menu": {
    "home": "Home",
    "seo-nav": "SEO Tools Navigator",
    "geo-nav": "GEO Navigator",
    "aeo-nav": "AEO Navigator",
    "llms-txt": "llms.txt Generator",
    "ai-checker": "AI Visibility Checker",
    "glossary": "AI SEO Glossary",
    "schema-generator": "Schema Generator",
    "domain-namer": "AI Domain Namer",
    "domain-namer-naming": "AI Naming",
    "domain-namer-autofill": "Auto-fill Names",
    "domain-namer-rank": "Rank Candidates",
    "articles": "Articles",
    "tutorials": "Tutorials",
    "news": "News",
    "backlinks": "Backlink Service",
    "auth": "Auth",
    "buttons": "Buttons",
    "timelines": "Timelines",
    "dashboard": "Dashboard",
    "billing": "Billing",
    "login": "Login",
    "preferences": "Account preferences",
    "payments": "Payments",
    "settings": "Application settings",
    "pricing-plans": "Pricing plans",
    "payment-methods": "Payment methods",
    "signup": "Signup",
    "recover-password": "Recover password",
    "recover-password-email": "Recover password email",
    "404": "404",
    "faq": "FAQ",
    "users": "Users",
    "projects": "Projects"
  },
  "footer": {
    "home": "Home",
    "about": "About Us",
    "contact": "Contact Us",
    "privacy": "Privacy Policy",
    "terms": "Terms of Service",
    "backlinks": "Backlink Service",
    "rights": "All rights reserved.",
    "tagline": "A tools directory and knowledge hub for the AI search era — SEO, GEO and AEO.",
    "lastUpdated": "Last updated"
  },
  "messages": {
    "all": "See all messages",
    "new": "New messages from {name}",
    "mark_as_read": "Mark As Read"
  },
  "navbar": {
    "messageUs": "Web development inquiries:",
    "repository": "GitHub Repo"
  },
  "notifications": {
    "all": "See all notifications",
    "less": "See less notifications",
    "mark_as_read": "Mark as read",
    "sentMessage": "sent you a message",
    "uploadedZip": "uploaded a new Zip file with {type}",
    "startedTopic": "started a new topic"
  },
  "user": {
    "language": "Change language",
    "logout": "Logout",
    "profile": "Profile",
    "settings": "Settings",
    "billing": "Billing",
    "faq": "FAQ",
    "helpAndSupport": "Help & support",
    "projects": "Projects",
    "account": "Account",
    "explore": "Explore"
  },
  "treeView": {
    "basic": "Basic",
    "icons": "Icons",
    "selectable": "Selectable",
    "editable": "Editable",
    "advanced": "Advanced"
  },
  "chat": {
    "title": "Chat",
    "sendButton": "Send"
  },
  "spacingPlayground": {
    "value": "Value",
    "margin": "Margin",
    "padding": "Padding"
  },
  "spacing": {
    "title": "Spacing"
  },
  "cards": {
    "cards": "Cards",
    "fixed": "Fixed",
    "floating": "Floating",
    "contentText": "The unique stripes of zebras make them one of the animals most familiar to people.",
    "contentTextLong": "The unique stripes of zebras make them one of the animals most familiar to people. They occur in a variety of habitats, such as grasslands, savannas, woodlands, thorny scrublands, mountains, and coastal hills. Various anthropogenic factors have had a severe impact on zebra populations, in particular hunting for skins and habitat destruction. Grévy's zebra and the mountain zebra are endangered. While plains zebras are much more plentiful, one subspecies, the quagga.",
    "rowHeight": "Row height",
    "title": {
      "default": "Default",
      "withControls": "With controls",
      "customHeader": "Custom header",
      "withoutHeader": "Without header",
      "withImage": "With Image",
      "withTitleOnImage": "With title on image",
      "withCustomTitleOnImage": "With custom title on image",
      "withStripe": "With stripe",
      "withBackground": "With background"
    },
    "button": {
      "main": "Main",
      "cancel": "Cancel",
      "showMore": "Show More",
      "readMore": "Show More"
    },
    "link": {
      "edit": "Edit",
      "setAsDefault": "Set as default",
      "delete": "Delete",
      "traveling": "Traveling",
      "france": "France",
      "review": "Review",
      "feedback": "Leave feedback",
      "readFull": "Read full article",
      "secondaryAction": "Secondary action",
      "action1": "Action 1",
      "action2": "Action 2"
    }
  },
  "colors": {
    "themeColors": "Theme Colors",
    "extraColors": "Extra Colors",
    "gradients": {
      "basic": {
        "title": "Button Gradients"
      },
      "hovered": {
        "title": "Hovered Button Gradients",
        "text": "Lighten 15% applied to an original style (gradient or flat color) for hover state."
      },
      "pressed": {
        "title": "Pressed Button Gradients",
        "text": "Darken 15% applied to an original style (gradient or flat color) for pressed state."
      }
    }
  },
  "tabs": {
    "alignment": "Tabs alignment",
    "overflow": "Tabs overflow",
    "hidden": "Tabs with hidden slider",
    "grow": "Tabs grow"
  },
  "helpAndSupport": "Help & support",
  "aboutVuesticAdmin": "About Vuestic Admin",
  "supportAndConsulting": "Support & Consulting",
  "search": {
    "placeholder": "Search..."
  },
  "buttonSelect": {
    "dark": "Dark",
    "light": "Light"
  },
  "vuestic": {
    "search": "Search",
    "noOptions": "Items not found",
    "ok": "OK",
    "cancel": "Cancel",
    "uploadFile": "Upload file",
    "undo": "Undo",
    "dropzone": "Drop files here to upload",
    "fileDeleted": "File deleted",
    "closeAlert": "close alert",
    "backToTop": "back to top",
    "toggleDropdown": "toggle dropdown",
    "carousel": "carousel",
    "goPreviousSlide": "go previous slide",
    "goNextSlide": "go next slide",
    "goSlide": "go slide {index}",
    "slideOf": "slide {index} of {length}",
    "close": "close",
    "openColorPicker": "open color picker",
    "colorSelection": "color selection",
    "colorName": "color {color}",
    "decreaseCounter": "decrease counter",
    "increaseCounter": "increase counter",
    "selectAllRows": "select all rows",
    "sortColumnBy": "sort column by {name}",
    "selectRowByIndex": "select row {index}",
    "resetDate": "reset date",
    "nextPeriod": "next period",
    "switchView": "switch view",
    "previousPeriod": "previous period",
    "removeFile": "remove file",
    "reset": "reset",
    "pagination": "pagination",
    "goToTheFirstPage": "go to the first page",
    "goToPreviousPage": "go to the previous page",
    "goToSpecificPage": "go to the {page} page",
    "goToSpecificPageInput": "enter the page number to go",
    "goNextPage": "go next page",
    "goLastPage": "go last page",
    "currentRating": "current rating {value} of {max}",
    "voteRating": "vote rating {value} of {max}",
    "optionsFilter": "options filter",
    "splitPanels": "split panels",
    "movePaginationLeft": "move pagination left",
    "movePaginationRight": "move pagination right",
    "resetTime": "reset time",
    "closeToast": "close toast",
    "selectedOption": "Selected option",
    "noSelectedOption": "Option is not selected",
    "breadcrumbs": "breadcrumbs",
    "counterValue": "counter value",
    "selectedDate": "selected date",
    "selectedTime": "selected time",
    "progressState": "progress state",
    "color": "color",
    "next": "Next",
    "back": "Previous",
    "finish": "Finish",
    "step": "step",
    "progress": "progress",
    "loading": "Loading",
    "sliderValue": "Current slider value is {value}",
    "switch": "Switch",
    "inputField": "Input field",
    "fileTypeIncorrect": "File type is incorrect",
    "select": "Select an option"
  },
  "common": {
    "search": "Search",
    "loading": "Loading...",
    "clearFilters": "Clear filters",
    "readMore": "Read more",
    "visit": "Visit",
    "free": "Free",
    "aiFriendly": "AI-Friendly",
    "back": "Back",
    "noResults": "No matching results"
  },
  "articlesPage": {
    "badge": "Articles",
    "heroTitle": "SEO/GEO/AEO Article Library",
    "heroSubtitle": "The latest search optimization insights, industry trends, and hands-on guides to help you keep up with AI search.",
    "searchPlaceholder": "Search article titles, tags...",
    "categories": "Categories",
    "all": "All Articles",
    "catSeo": "SEO",
    "catGeo": "GEO",
    "catAeo": "AEO",
    "catTools": "Tools",
    "empty": "No matching articles found",
    "author": "By {name}",
    "readTime": "{n} min read",
    "pageInfo": "Page {current} / {total} ({count} articles)",
    "seoTitle": "SEO/GEO/AEO In-Depth Articles — Hands-On Guides for the AI Search Era",
    "seoDescription": "In-depth SEO, GEO and AEO articles sharing real-world optimization experience for the AI search era: GEO guides, AEO strategy, llms.txt, structured data and more.",
    "seoKeywords": "SEO articles,GEO optimization,AEO strategy,AI search optimization,llms.txt,structured data"
  },
  "newsPage": {
    "badge": "Industry News",
    "heroTitle": "SEO/GEO/AEO Industry News",
    "heroSubtitle": "Track the latest search engine algorithm updates and AI search trends.",
    "searchPlaceholder": "Search news...",
    "categories": "Categories",
    "all": "All News",
    "impact": "Impact",
    "impactAll": "All",
    "impactHigh": "High impact",
    "impactMedium": "Medium impact",
    "impactLow": "Low impact",
    "empty": "No matching news",
    "readOriginal": "Read full article",
    "noLink": "No source link",
    "pageInfo": "Page {current} / {total} ({count} articles)",
    "seoTitle": "SEO/GEO News — Latest Search Engine & AI Updates",
    "seoDescription": "Track Google algorithm updates, ChatGPT and Perplexity features, Claude search, and the latest AI search industry news.",
    "seoKeywords": "SEO news,Google algorithm updates,AI search trends,GEO news"
  },
  "tutorialsPage": {
    "badge": "Online Courses",
    "heroTitle": "Complete SEO/GEO/AEO Course System",
    "heroSubtitle": "From beginner to advanced — learn modern search optimization skills systematically.",
    "searchPlaceholder": "Search courses...",
    "categories": "Course Categories",
    "all": "All Courses",
    "catSeo": "SEO Courses",
    "catGeo": "GEO Courses",
    "catAeo": "AEO Courses",
    "level": "Difficulty",
    "levelAll": "All Levels",
    "levelBeginner": "Beginner",
    "levelIntermediate": "Intermediate",
    "levelAdvanced": "Advanced",
    "empty": "No matching courses",
    "minutes": "{n} min",
    "students": "{n} students",
    "lessons": "{n} lessons",
    "viewCourse": "View course",
    "seoTitle": "SEO/GEO/AEO Tutorials — Hands-On Search Optimization Courses",
    "seoDescription": "Systematic SEO, GEO and AEO tutorials from beginner to advanced, covering technical SEO, keyword research, GA4 analytics and core skills.",
    "seoKeywords": "SEO tutorials,GEO courses,AEO learning,search optimization basics"
  },
  "detail": {
    "home": "Home",
    "articles": "Articles",
    "news": "News",
    "tutorials": "Tutorials",
    "backToArticles": "Back to articles",
    "backToNews": "Back to news",
    "backToTutorials": "Back to tutorials",
    "relatedArticles": "Related articles",
    "relatedNews": "Related news",
    "relatedTutorials": "Related tutorials",
    "related": "Related content",
    "prev": "Previous",
    "next": "Next",
    "notFoundArticle": "Article not found",
    "notFoundNews": "News not found",
    "notFoundTutorial": "Tutorial not found",
    "glossaryTooltip": "View term definition",
    "instructor": "Instructor: {name}",
    "lessonsCount": "{n} lessons",
    "studentsCount": "{n} students",
    "overview": "Course overview",
    "outline": "Course outline",
    "lessonsTotal": "{n} lessons total",
    "comingSoon": "Course content is being prepared. Stay tuned.",
    "durationMin": "{n} min",
    "durationHour": "{h} h",
    "durationHourMin": "{h} h {m} min"
  },
  "notFound": {
    "title": "Page not found",
    "text": "The page you're looking for doesn't exist or has been moved. Please return to the homepage.",
    "back": "Back to home"
  },
  "seoNavPage": {
    "badge": "SEO Tools Directory",
    "heroTitle": "Discover the best SEO tools",
    "heroSubtitle": "{n}+ curated professional SEO tools across {c} core areas — keyword research, technical audits, content optimization and AI search monitoring",
    "searchPlaceholder": "Search tools by name, feature or tag...",
    "searchAria": "Search SEO tools",
    "statTools": "Curated tools",
    "statFree": "Free",
    "statAi": "AI-Friendly",
    "statCategories": "Categories",
    "filterFreeOnly": "Free only",
    "filterAi": "AI-Friendly",
    "allTools": "All tools",
    "featuredTitle": "Featured picks",
    "featuredDesc": "Core tools every site owner needs — each battle-tested in the field",
    "visitAria": "Visit {name} (opens in a new tab)",
    "badgeFree": "Free",
    "badgeAi": "AI-Friendly",
    "badgeApi": "API",
    "badgeAiShort": "AI",
    "toolsFound": "tools found",
    "toolsUnit": "tools",
    "viewAllInCategory": "View all {count}",
    "clearFilters": "Clear filters",
    "empty": "No matching tools — try a different keyword",
    "visitHint": "Visit",
    "tipsTitle": "SEO tips for site owners",
    "tip1Title": "Start with keyword research",
    "tip1Body": "Find breakout terms with <strong>Exploding Topics</strong>, uncover real user questions with <strong>AnswerThePublic</strong>, and validate volume with <strong>Google Keyword Planner</strong>.",
    "tip2Title": "Run regular technical checks",
    "tip2Body": "Crawl your whole site monthly with <strong>Screaming Frog</strong>, check Core Web Vitals with <strong>PageSpeed Insights</strong>, and fix technical SEO issues promptly.",
    "tip3Title": "AI-assisted content optimization",
    "tip3Body": "Score your content with <strong>SurferSEO</strong> or <strong>Clearscope</strong>, and use <strong>Frase.io</strong> to quickly draft high-ranking article outlines.",
    "tip4Title": "Prepare for the AI search era",
    "tip4Body": "Track how often your brand is cited across AI tools with <strong>GEO/AEO Tracker</strong>, and improve visibility in Google AI Overviews with <strong>SearchAttention</strong>.",
    "tip5Title": "Build high-quality backlinks",
    "tip5Body": "Analyze competitors' backlink sources with <strong>Majestic</strong>, then automate outreach with <strong>Respona</strong> or <strong>BacklinkGPT</strong>.",
    "tip6Title": "Make data-driven decisions",
    "tip6Body": "Combine <strong>Google Search Console</strong> data with competitor traffic from <strong>Similarweb</strong> to pinpoint your biggest growth opportunities.",
    "seoTitle": "SEO Tools Directory — 100+ Curated SEO Tools",
    "seoDescription": "A curated directory of 100+ SEO tools across keyword research, backlink analysis, technical SEO, content optimization and local SEO to help you rank higher in Google. Free tools highlighted.",
    "seoKeywords": "SEO tools,keyword research tools,backlink analysis,technical SEO,Ahrefs,Semrush,Google Search Console"
  },
  "geoNavPage": {
    "badge": "GEO · AEO · AI Search Navigator",
    "heroTitleMain": "Generative Engine Optimization Tools",
    "heroTitleAccent": "Full Directory",
    "heroSubtitle": "A curated set of <strong>{n}+</strong> tools and resources across 6 categories — <strong>China SaaS</strong>、<strong>China Providers</strong>、<strong>Global Tools</strong>、<strong>SEO Add-ons</strong>、<strong>Free Tools</strong>、<strong>Open-Source Projects</strong>",
    "searchPlaceholder": "Search tools by name, feature or tag...",
    "searchAria": "Search GEO tools",
    "regionAll": "All",
    "regionCn": "🇨🇳 China Tools",
    "regionGlobal": "🌍 Global Tools",
    "statTools": "Curated Tools",
    "statFree": "Has Free Tier",
    "statOss": "Open-Source Projects",
    "concept1": "<strong>GEO</strong> = Generative Engine Optimization",
    "concept2": "<strong>AEO</strong> = Answer Engine Optimization",
    "concept3": "<strong>llms.txt</strong> = AI-readable structure standard",
    "filterHasFree": "Has Free",
    "filterOpenSource": "Open Source",
    "allTools": "All tools",
    "featuredTitle": "Featured picks",
    "featuredBadge": "Editor’s choice",
    "visitAria": "Visit {name} (opens in a new tab)",
    "badgeFree": "Free",
    "badgeFreeTier": "Has Free Tier",
    "badgeHasFree": "Has Free",
    "badgeOss": "Open Source",
    "badgeApi": "API",
    "badgeCn": "🇨🇳 China",
    "badgeGlobal": "🌍 Global",
    "resultCount": "Found <strong>{n}</strong> tools",
    "clearFilters": "Clear filters",
    "clearAllFilters": "Clear all filters",
    "empty": "No matching tools — try a different keyword",
    "toolsUnit": "tools",
    "viewAllInCategory": "View all {count}",
    "visitHint": "Visit",
    "tipsTitle": "GEO playbook",
    "tip1Title": "Step 1: Baseline your status",
    "tip1Body": "Use <strong>Lens GEO</strong> (free) or <strong>HubSpot AI Grader</strong> (free) to quickly baseline your brand’s visibility in major AI engines and decide whether systematic optimization is needed.",
    "tip2Title": "Step 2: Add llms.txt",
    "tip2Body": "Use <strong>aeo.js</strong> or <strong>the LLMrefs llms.txt generator</strong> (free) to add an llms.txt file that tells AI crawlers your site’s core structure — foundational GEO work.",
    "tip3Title": "Step 3: Structured data",
    "tip3Body": "Add JSON-LD Schema (Article, FAQ, Organization) to key pages and validate with <strong>Google Rich Results Test</strong> — structured data is key for AI engines to understand your entities.",
    "tip4Title": "Step 4: Improve content quality",
    "tip4Body": "Princeton’s KDD 2024 research shows that adding <strong>statistics</strong>、<strong>FAQ format</strong>、<strong>authoritative citations</strong> and clear <strong>heading hierarchy</strong> significantly raises AI citation rates. Use <strong>Frase.io</strong> to assist content analysis.",
    "tip5Title": "Step 5: Monitor continuously",
    "tip5Body": "For China, try <strong>ImpetaAI</strong> (50+ metrics) or <strong>GEOWISE</strong> (content + monitoring); for global, try <strong>Otterly.AI</strong> ($29/mo) or <strong>Profound</strong> (enterprise).",
    "tip6Title": "Step 6: Build E-E-A-T",
    "tip6Body": "On <strong>Wikidata</strong> establish your brand entity, and via <strong>Chuanshenggang</strong> (128 state-media outlets) or other authoritative media, raise your brand’s E-E-A-T trust signals in AI engines.",
    "seoTitle": "GEO Tools Directory — Generative Engine Optimization Tools",
    "seoDescription": "A directory of 60+ GEO (Generative Engine Optimization) tools to help your content get cited by AI search engines like ChatGPT, Perplexity and Google AI Overviews — covering AI visibility monitoring, brand mention analysis and llms.txt.",
    "seoKeywords": "GEO tools,generative engine optimization,AI search optimization,ChatGPT SEO,Perplexity optimization,AI visibility"
  },
  "aeoNavPage": {
    "badge": "AEO · Answer Engine Optimization Navigator",
    "heroTitleMain": "Answer Engine Optimization Tools",
    "heroTitleAccent": "Full Directory",
    "heroSubtitle": "A curated set of <strong>{n}+</strong> tools and resources across 6 categories — <strong>AEO-Focused SaaS</strong>、<strong>Enterprise SEO Modules</strong>、<strong>Content Optimization</strong>、<strong>Question Research</strong>、<strong>Structured Data</strong>、<strong>China Platforms</strong>",
    "searchPlaceholder": "Search tools by name, feature or tag...",
    "searchAria": "Search AEO tools",
    "concept1": "<strong>AEO</strong> = Answer Engine Optimization",
    "concept2": "<strong>llms.txt</strong> = AI-readable structure standard",
    "concept3": "<strong>JSON-LD</strong> = structured-data markup",
    "concept4": "<strong>PAA</strong> = People Also Ask answer box",
    "statTools": "Curated Tools",
    "statOss": "⭐ Open-Source Projects",
    "statFree": "🆓 Has Free Tier",
    "statChina": "🇨🇳 China Platforms",
    "filterHasFree": "Has Free",
    "filterOpenSource": "Open Source",
    "allTools": "All tools",
    "featuredTitle": "Featured picks",
    "featuredBadge": "Editor’s choice",
    "visitAria": "Visit {name} (opens in a new tab)",
    "badgeFree": "Free",
    "badgeFreeTier": "Has Free Tier",
    "badgeHasFree": "Has Free",
    "badgeOss": "Open Source",
    "badgeApi": "API",
    "resultCount": "Found <strong>{n}</strong> tools",
    "clearFilters": "Clear filters",
    "clearAllFilters": "Clear all filters",
    "empty": "No matching tools — try a different keyword",
    "toolsUnit": "tools",
    "viewAllInCategory": "View all {count}",
    "visitHint": "Visit",
    "tipsTitle": "AEO playbook",
    "tip1Title": "Step 1: Baseline AI visibility",
    "tip1Body": "Use <strong>Otterly.AI</strong> ($29/mo, 15,000+ users) or <strong>GetCito/Elmo</strong> (open source, free) to quickly baseline your brand’s exposure across ChatGPT, Perplexity and Gemini. For China-focused brands, <strong>Lens GEO</strong> (free) is a top pick.",
    "tip2Title": "Step 2: Mine AEO question keywords",
    "tip2Body": "Use <strong>AlsoAsked</strong> (a visual PAA question tree) and <strong>AnswerThePublic</strong> (5W1H question aggregation) to find real user intent and prioritize the high-frequency questions AI cites most.",
    "tip3Title": "Step 3: Write answer-friendly content",
    "tip3Body": "Use <strong>Frase.io</strong> (AI summaries + FAQ generation, $14.99/mo) or <strong>Surfer SEO</strong> (content scoring + LLM optimization) to write clear, semantically complete content that ranks on Google and gets cited by AI.",
    "tip4Title": "Step 4: Add structured data",
    "tip4Body": "On WordPress, use <strong>Rank Math</strong> to auto-generate FAQ/HowTo Schema; on modern frameworks use <strong>aeo.js</strong> (⭐76) to one-click generate llms.txt + JSON-LD; then validate with <strong>the Google Rich Results Test</strong> (free).",
    "tip5Title": "Step 5: Scale to enterprise",
    "tip5Body": "Teams with an existing SEO stack can enable the AEO modules in <strong>Semrush AI Visibility</strong> or <strong>Ahrefs Brand Radar</strong> — extending into AEO without replacing current tools.",
    "tip6Title": "Step 6: Cover China AI engines",
    "tip6Body": "For the China market, use <strong>AIDSO</strong> (DSO+GEO+AEO in one) or <strong>Yishan Tech</strong> (7 proprietary systems) to cover major domestic platforms like Doubao, DeepSeek, Kimi and Tongyi Qianwen and build AI-visibility advantage.",
    "seoTitle": "AEO Tools Directory — Answer Engine Optimization Tools",
    "seoDescription": "A directory of 50+ AEO (Answer Engine Optimization) tools to help your content appear in Google featured snippets, AI direct answers and voice search — including Schema generators, snippet optimization and structured-data validators.",
    "seoKeywords": "AEO tools,answer engine optimization,featured snippets,Schema markup,structured data,voice search optimization"
  },
  "aiCheckerPage": {
    "badge": "AI Search Visibility · Aggregated Checkers",
    "heroTitleMain": "AI Mode SEO Checker",
    "heroTitleAccent": "Tools Directory",
    "heroSubtitle": "An aggregated <strong>{n}+</strong> AI-visibility checkers covering <strong>9 major China AI engines</strong> and <strong>major global AI platforms</strong> — from free quick checks to enterprise monitoring, helping brands fully understand their AI-search exposure",
    "journey1": "Pick a checker",
    "journey2": "Get a report",
    "journey3": "Find gaps",
    "journey4": "Optimize",
    "journey5": "Re-check",
    "searchPlaceholder": "Search tools by name, platform or feature...",
    "searchAria": "Search AI visibility tools",
    "regionCn": "🇨🇳 China Tools",
    "regionGlobal": "🌍 Global Tools",
    "statTools": "Curated Tools",
    "statFree": "Has Free Tier",
    "filterFreeOnly": "Free only",
    "allTools": "All tools",
    "featuredTitle": "Quick check",
    "featuredBadge": "Free, direct",
    "visitAria": "Visit {name} (opens in a new tab)",
    "badgeFree": "Free",
    "badgeFreeTier": "Has Free Tier",
    "badgeHasFree": "Has Free",
    "badgeApi": "API",
    "badgeCn": "🇨🇳 China",
    "badgeGlobal": "🌍 Global",
    "resultCount": "Found <strong>{n}</strong> tools",
    "clearFilters": "Clear filters",
    "clearAllFilters": "Clear all filters",
    "empty": "No matching tools — try a different keyword",
    "toolsUnit": "tools",
    "visitHint": "Visit",
    "tipsTitle": "How to improve AI visibility after a check",
    "tip1Title": "Step 1: Free baseline check",
    "tip1Body": "Use <strong>Lens GEO</strong> (China) or <strong>AppearOnAI</strong> (global, free) to get a baseline AI visibility report and confirm whether major AI engines mention your brand.",
    "tip2Title": "Step 2: Add llms.txt",
    "tip2Body": "Use <strong>an llms.txt generator</strong> to create an llms.txt file that tells AI crawlers your site’s core content — the most basic step toward better AI visibility.",
    "tip3Title": "Step 3: Structured data",
    "tip3Body": "Add JSON-LD Schema (Article, FAQ, Organization) to important pages and validate with <strong>the Google Rich Results Test</strong> to help AI engines understand your entities.",
    "tip4Title": "Step 4: Improve content quality",
    "tip4Body": "Add <strong>statistics</strong>, <strong>FAQ format</strong> and <strong>authoritative citations</strong>, and use <strong>Frase.io</strong> to analyze the content patterns AI cites — greatly raising citation odds.",
    "tip5Title": "Step 5: Monitor continuously",
    "tip5Body": "For China, choose <strong>SheepGeo</strong> (9 models) or <strong>ImpetaAI</strong> (50+ metrics); for global, choose <strong>Otterly.AI</strong> ($29/mo) for ongoing tracking and a re-check habit.",
    "tip6Title": "Step 6: Re-check monthly",
    "tip6Body": "AI engines update their models and training data monthly, so re-check your visibility with free tools <strong>monthly</strong> to track results and adjust your strategy in time.",
    "seoTitle": "AI Mode SEO Checker — Test Your Visibility in AI Search",
    "seoDescription": "Check how your site appears in Google AI Mode, AI Overviews, ChatGPT, Perplexity, Claude and Gemini. Compare free and paid AI Mode SEO checkers and improve your AI search visibility.",
    "seoKeywords": "AI Mode SEO checker,AI Overviews checker,AI visibility checker,GEO checker,ChatGPT visibility,AI search visibility",
    "faqSectionTitle": "AI Mode SEO Checker — Common Questions",
    "faq1Q": "What is an AI Mode SEO checker?",
    "faq1A": "An AI Mode SEO checker measures whether your brand and pages are mentioned, cited or linked inside AI search answers — Google AI Mode and AI Overviews, ChatGPT, Perplexity, Claude and Gemini — instead of only tracking classic blue-link rankings.",
    "faq2Q": "How do I check my site in Google AI Mode?",
    "faq2A": "Pick a checker from the list above, enter your domain or target queries, and the tool runs them against AI engines and reports where you are cited. Free tools like AppearOnAI give a quick baseline; paid platforms add continuous monitoring.",
    "faq3Q": "Why does my site rank on Google page one but not appear in AI answers?",
    "faq3A": "AI engines favor content that is easy to quote: clear question-based headings, concise direct answers, statistics, original data and FAQ schema. Classic rankings help, but without answer-shaped, structured content AI models usually cite someone else.",
    "faq4Q": "What should I do after an AI visibility check?",
    "faq4A": "Follow the steps on this page: get a free baseline report, add llms.txt, deploy Article and FAQ structured data, strengthen content with statistics and citations, then re-check monthly — AI answers shift as models and training data update."
  },
  "glossaryPage": {
    "badge": "AI SEO Glossary · {n}+ terms",
    "heroTitleMain": "The complete AI SEO glossary",
    "heroTitleAccent": "GEO · AEO · LLMO & more",
    "heroSubtitle": "Covering <strong>{n}+</strong> core terms across 5 categories — <strong>AI Search Optimization</strong>、<strong>Traditional SEO</strong>、<strong>LLM Tech</strong>、<strong>Structured Data</strong> and <strong>Metrics</strong> — the internal-linking hub for the whole site.",
    "searchPlaceholder": "Search terms, names or definitions...",
    "searchAria": "Search glossary terms",
    "sidebarCategory": "Browse by category",
    "allTerms": "All terms",
    "sidebarAlpha": "Alphabetical index",
    "resultShowing": "Showing <strong>{n}</strong> / {total} terms",
    "clearFilters": "Clear filters",
    "empty": "No matching terms",
    "viewTool": "View tool",
    "related": "Related:",
    "ctaQuestion": "Can’t find the term you need?",
    "ctaSuggest": "Suggest a term →",
    "footerMeta": "Last updated: May 2026 · {n} terms",
    "seoTitle": "SEO/GEO/AEO Glossary — Search Optimization Terms Explained",
    "seoDescription": "200+ SEO, GEO and AEO terms explained, covering technical SEO, content optimization, generative engine optimization and structured data. A search optimization dictionary for beginners and pros alike.",
    "seoKeywords": "SEO glossary,GEO terms,AEO terms,search optimization dictionary,Schema terms,what is llms.txt"
  },
  "llmsTxtPage": {
    "badge": "llms.txt · AI-readable site card",
    "heroTitleMain": "llms.txt",
    "heroTitleAccent": "Tools directory",
    "heroSub": "Like <strong>robots.txt</strong>, but built for <strong>large AI models</strong> — it tells ChatGPT, Perplexity and Gemini what your site offers. Proposed by <strong>Jeremy Howard (fast.ai)</strong> in 2024, it has become a core GEO/AEO infrastructure standard.",
    "statSpecYear": "📅 Spec year",
    "statToolsListed": "🔧 Tools listed",
    "statTemplates": "📋 Built-in templates",
    "statFreeVal": "Free",
    "statAllFree": "✨ All free",
    "concept1": "<strong>llms.txt</strong> = AI-readable structure standard",
    "concept2": "<strong>GEO/AEO</strong> infrastructure essential",
    "concept3": "Format: Markdown + link list",
    "tabTools": "Recommended tools",
    "tabTemplates": "Template library",
    "tabGuide": "Format guide",
    "tplIntro": "llms.txt templates by industry — click to copy, paste into any editor to adjust, then upload to your site root.",
    "copyBtn": "Copy template",
    "copiedBtn": "Copied!",
    "tplHowTitle": "How to use the templates",
    "tplHow1": "Click \"Copy template\" to copy the content to your clipboard",
    "tplHow2": "Paste into any text editor and edit the site name, links and descriptions to match your site",
    "tplHow3": "Save the file as <code>llms.txt</code> and upload it to your site root",
    "tplHow4": "Visit <code>https://yoursite.com/llms.txt</code> to verify it’s accessible",
    "tplHow5": "Open \"Recommended tools\" → \"Submit & indexing platforms\" to submit it for indexing",
    "gWhatTitle": "What is llms.txt?",
    "gWhatP1": "<code>llms.txt</code> is a plain-text file in your site root, designed specifically for large AI models — it tells the LLM \"<strong>what this site is about, which pages are worth reading, and how to understand it</strong>\".",
    "gWhatP2": "Proposed by <strong>Jeremy Howard (fast.ai founder)</strong> in 2024. Just as <code>robots.txt</code> is for search engine crawlers, <code>llms.txt</code> is a semantic index for AI models. Cloudflare, Anthropic, Perplexity and other ecosystem tools already read it.",
    "gFormatTitle": "Standard format",
    "gFormatCode": "# Site name\n\n> Describe in one sentence what this site is about\n\n## Key pages\n- [page name](URL): short note\n- [about us](https://example.com/about): company intro\n\n## Products / Services\n- [Product A](https://example.com/product): feature notes\n\n## Optional\n- [Blog](https://example.com/blog): articles",
    "gFormatNote": "Minimal format: Markdown + a link list, so LLMs can read your site structure at a glance.",
    "gBestTitle": "Writing best practices",
    "gBest1": "<strong>Make the one-line description precise</strong>: include business type + target users + core value",
    "gBest2": "<strong>Make link descriptions specific</strong>: avoid \"Read more\"; clearly describe the page content",
    "gBest3": "<strong>Use Optional to set priority</strong>: core content first, secondary content under Optional",
    "gBest4": "<strong>Keep it concise</strong>: 3–8 links per section is ideal",
    "gBest5": "<strong>Update regularly</strong>: refresh your llms.txt after any major site redesign",
    "gDeployTitle": "How to deploy",
    "gDeploy1": "Use the template library to write or copy an <code>llms.txt</code> that fits your site",
    "gDeploy2": "Upload the file to your site root (next to <code>robots.txt</code>)",
    "gDeploy3": "Verify it’s accessible: <code>https://yoursite.com/llms.txt</code>",
    "gDeploy4": "Submit to AI indexing platforms for more exposure",
    "gVsTitle": "vs robots.txt",
    "cmpDimension": "Dimension",
    "cmpAudience": "Audience",
    "cmpAudienceR": "search engine crawlers",
    "cmpAudienceL": "large AI models (LLMs)",
    "cmpFunc": "Core function",
    "cmpFuncR": "controls crawl permissions",
    "cmpFuncL": "provides semantic understanding",
    "cmpFormat": "Format",
    "cmpFormatR": "directive syntax",
    "cmpFormatL": "Markdown description",
    "cmpIntro": "Introduced",
    "cmpRole": "GEO/AEO role",
    "cmpRoleR": "Indirect",
    "cmpRoleL": "Directly raises AI citation rate",
    "seoTitle": "llms.txt Tools — AI Crawler Site Index Configuration",
    "seoDescription": "llms.txt generators, validators and templates in one place. Build an AI-readable semantic index file so ChatGPT, Perplexity, Claude and other AI models understand and cite your site content better.",
    "seoKeywords": "llms.txt,AI crawler configuration,AI index file,ChatGPT site index,Perplexity,AI visibility"
  },
  "schemaGeneratorPage": {
    "badge": "Structured Data · Schema Markup Tools",
    "heroTitleMain": "Schema Markup Generator",
    "heroTitleAccent": "Directory & Template Center",
    "heroSubtitle": "An aggregated <strong>{n}+</strong> Schema generators and tools, covering <strong>{c}</strong> common types with JSON-LD templates and field notes — quickly add structured data to your site and improve rich results and AI citations.",
    "wf1": "Pick a Schema type",
    "wf2": "Generate code with a tool",
    "wf3": "Copy the JSON-LD template",
    "wf4": "Google official validation ✅",
    "schemaSuffix": "Schema",
    "aeoTipTitle": "AEO key tips",
    "requiredFields": "Required fields",
    "jsonLdTemplate": "JSON-LD template code",
    "copyCode": "Copy code",
    "copiedCode": "Copied!",
    "recommendedTools": "Recommended tools",
    "priceFree": "Free",
    "pricePaid": "Paid",
    "openTool": "Open tool",
    "hasFreeTier": "Has free tier",
    "levelBeginner": "For beginners",
    "levelAdvanced": "Advanced",
    "levelAuto": "Fully automated",
    "validateTip": "After generating code, always validate with <strong>Google Rich Results Test</strong> and <strong>Schema.org Validator</strong>",
    "allPurpose": "🥇 All-purpose pick",
    "aiAuto": "🤖 AI automation",
    "aiAutoTip": "Great for WordPress owners or anyone who wants \"set once, runs forever\"",
    "implTips": "Implementation tips",
    "tip1": "Place JSON-LD in the <code>&lt;head&gt;</code> or <code>&lt;body&gt;</code> — either works",
    "tip2": "You can stack multiple Schema types on one page",
    "tip3": "FAQ Schema works best for AI search citations",
    "tip4": "Google starts recognizing it 1–2 weeks after deployment",
    "tip5": "Re-validate Schema after every content update",
    "seoTitle": "FAQ Schema Generator — Free JSON-LD Schema Markup Tool",
    "seoDescription": "Free FAQ schema generator and JSON-LD markup tool. Generate and validate FAQ, Article, Product, HowTo and 20+ Schema types — copy-paste code that wins rich results.",
    "seoKeywords": "FAQ schema generator,schema markup generator,JSON-LD generator,structured data tool,FAQ Schema,Article Schema,rich results",
    "faqSectionTitle": "FAQ Schema Generator — Common Questions",
    "faq1Q": "What is a FAQ schema generator?",
    "faq1A": "A FAQ schema generator is a tool that turns your questions and answers into FAQPage JSON-LD structured data. You paste the generated code into your page, and Google can show your Q&A as rich results, while AI search engines can parse and cite it more easily.",
    "faq2Q": "How do I generate FAQ schema markup with this page?",
    "faq2A": "Select the FAQ type above, copy the JSON-LD template, replace the sample questions and answers with your own, then paste the code into your page's head or body. Finally validate it with the Google Rich Results Test linked in the tools panel.",
    "faq3Q": "Does FAQ schema still help SEO in 2026?",
    "faq3A": "Yes. Google now shows FAQ rich results mainly for authoritative sites, but FAQPage markup remains one of the strongest machine-readable Q&A formats for AI Overviews, ChatGPT and Perplexity citations, and it clarifies page entities for classic search too.",
    "faq4Q": "Which other Schema types can I generate here?",
    "faq4A": "Besides FAQ, this directory covers Article, Product, HowTo, BreadcrumbList, Organization, Video, NewsArticle and 20+ other JSON-LD types, each with a copy-paste template, required-field notes and recommended generators and validators."
  },
  "domainNamerPage": {
    "badge": "AI Naming · Domain & Brand Check",
    "heroTitleMain": "AI Domain Namer",
    "heroTitleAccent": "Name it, check it, claim it",
    "heroSubtitle": "Describe your idea in one line — AI generates brandable English names, then instantly checks domain availability (RDAP) and Google brand collisions, so you only keep names you can actually register.",
    "needLabel": "Describe what you're building (one line)",
    "needPlaceholder": "e.g. a tool that helps indie developers batch-manage API keys; or an AI health-record app for pet owners",
    "tldLabel": "Which TLDs to check (click to toggle, add your own)",
    "tldAddPlaceholder": "Enter a TLD, e.g. .dev / .xyz (dot optional)",
    "tldAddBtn": "Add",
    "autofillLabel": "Auto-fill usable candidates (skip taken/colliding, multiple rounds until enough)",
    "autofillTargetLabel": "Target usable count (no collision + registrable)",
    "autofillHint": "Up to 8 rounds; stops once the target is met, otherwise returns what it found.",
    "runBtn": "Start naming",
    "haveCandidates": "Already have candidates? Check domains + collisions and rank them",
    "myNamesLabel": "Paste your candidates (one per line, or comma/space separated; with or without TLD)",
    "myNamesPlaceholder": "e.g.\nRollpik\nTieronic\nmybrand.com",
    "rankBtn": "Check & rank my candidates",
    "recoTitle": "AI Recommendation",
    "moreBtn": "🔄 Recommend more (new batch, factoring in all results)",
    "brandChecking": "checking…",
    "brandClash": "possible collision",
    "brandClear": "no collision",
    "brandFailed": "collision check failed",
    "viewLink": "view ↗",
    "regYearSuffix": " registered",
    "unknownTag": "to confirm",
    "takenGroup": "Taken / colliding ({n}) — click to toggle",
    "legendAvailable": "Registrable",
    "legendRegistered": "Already registered",
    "legendUnknown": "Lookup error",
    "seoTitle": "AI Domain Namer — Generate Brand Names & Check Availability",
    "seoDescription": "A free AI domain name generator: describe your product, get brandable English names, and instantly check domain availability and Google brand collisions. Built for founders and indie developers.",
    "seoKeywords": "AI domain generator,domain name generator,brand name generator,domain availability check,startup naming,business name ideas"
  },
  "domainNamerAutofillPage": {
    "heroAccent": "Auto-fill until you have enough",
    "heroSubtitle": "Set a target number of usable candidates — AI keeps generating across multiple rounds, automatically skipping taken or colliding names, until it reaches your goal.",
    "runBtn": "Start auto-fill",
    "seoTitle": "AI Domain Auto-fill — Batch Generate Registrable Domain Names",
    "seoDescription": "Set a target count and let AI auto-generate that many registrable, collision-free domain names across multiple rounds. Skips taken and colliding names automatically.",
    "seoKeywords": "bulk domain name generator,batch domain names,auto domain generator,available domain finder,startup naming"
  },
  "domainNamerRankPage": {
    "heroMain": "Rank Your Candidates",
    "heroAccent": "Domains + collisions, sorted",
    "heroSubtitle": "Already have a shortlist? Paste your candidate names and we'll check domain availability and Google brand collisions for each, then rank them by how usable they are.",
    "seoTitle": "Domain Candidate Ranker — Check Availability & Collisions",
    "seoDescription": "Paste your own candidate names and instantly check domain availability (RDAP) and Google brand collisions for each, then rank them by usability. Free.",
    "seoKeywords": "domain availability checker,bulk domain check,brand collision check,domain name ranking,check domain names"
  }
}
